import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import NotFound from '../views/NotFound.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'NotFound',
    component: NotFound
  },
  {
    path: '/:companyId',
    name: 'Home',
    component: Home,
    props: true
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
